import { ISandBoxReducerState } from "../../reducers/SandBoxReducer";
import { useMemo } from "react";

export const useSelectCurrentQuery = (state: ISandBoxReducerState) =>
  useMemo(() => {
    return state.query.queries[state.query.index];
  }, [state.query.index, state.query.queries]);
